import { URLS } from "constants/urls";
import apiRequests from "utils/apiRequests";

export const fetchSession = (subDomain, refresh = false) =>
  apiRequests.get(
    `${URLS.GET_SESSION}?subDomain=${subDomain}&refresh=${refresh}`
  );
